import React, { Component } from "react";
import { connect } from "react-redux";

import { withFormik } from "formik";

import * as Yup from "yup";

import styled from "styled-components";
import { Button } from "../../../../../../design-system";
import {
  Section,
  Wrapper,
  getRowItemObject,
  renderRowWithSingleItem,
  renderRowWithTwoItems,
} from "../../../../../common/FormUtils";
import { Author } from "../../../../../../types/Author";
import ActionButton from "../../../../../common/ActionButton";
import { ButtonWrapper } from "../../../../login/components/styles";
import tabConfig, { questionTabConfig } from "../../../config/tabConfig";
import Table from "../../../../../common/table";
import { InsertableTag } from "../../../../../common/SmallTextEditor";
import { Question } from "../../../../../../types/Question";
import FullScreenDialog from "../../../../../common/FullScreenDialog";
import QuestionForm from "./question/QuestionForm";
import { DAILY_STEP_TYPE, DailyStep, StepCta } from "../../../../../../types/DailyStep";
import ActionFormButton from "../../../../../common/ActionFormButton";
import firebase from "firebase";
import DB_PATH from "../../../../../../database/DB_PATH";
import {
  deleteMedia,
  uploadMedia,
} from "../../../../../../database/media/cloudflareMedia";
import { AudioFile } from "./types";
import { DEFAULT_ELEVENLABS_API_KEY } from "./mediaGeneratorConfig";
import {
  createOpenAIChatCompletion,
  createOpenAIImageGeneration,
} from "../../../../../../services/openaiFunctions";
// ffmpeg.wasm will be loaded dynamically from CDN
declare global {
  interface Window {
    FFmpeg: any;
  }
}

const MAX_CTAS = 3;
const MAX_CTA_LABEL = 60;

const SectionH4 = styled.h4`
  font-family: var(--font-sans);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  margin: 0 0 var(--space-3) 0;
`;

const FileInputLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 36px;
  padding: 0 var(--space-4);
  background: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition:
    background var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard);

  &:hover {
    background: var(--color-surface-subtle);
    border-color: var(--color-border-strong);
  }

  input[type="file"] {
    display: none;
  }
`;

const FieldHint = styled.div`
  font-family: var(--font-sans);
  font-size: var(--font-size-xs);
  color: var(--color-text-tertiary);
  margin-top: var(--space-2);

  code {
    background: var(--color-surface-inset);
    padding: 1px 6px;
    border-radius: var(--radius-sm);
    font-family: var(--font-mono);
    font-size: var(--font-size-xs);
    color: var(--color-text);
  }
`;

const SmallTextInput = styled.input`
  width: 100%;
  height: 32px;
  padding: 0 var(--space-3);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text);
  outline: none;
  transition:
    border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);

  &:focus {
    border-color: var(--color-accent);
    box-shadow: var(--shadow-focus);
  }

  &::placeholder {
    color: var(--color-text-tertiary);
  }
`;

const ImageRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3);
  background: var(--color-surface-subtle);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-3);
`;

const ImageThumb = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
`;

const AudioRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--color-border-subtle);

  &:last-child {
    border-bottom: none;
  }
`;

const AudioName = styled.span`
  flex: 1;
  min-width: 0;
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const EmptyHint = styled.div`
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text-tertiary);
  padding: var(--space-2) 0;
`;

const ProgressHint = styled.div`
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin-top: var(--space-2);
`;

const FileInputIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

type Props = {
  onChageFormToEditMode: Function;
  onToggleFullScreenDialog;
  setFieldValue: (field: string, value: any) => void;
  handleSubmit: any;
  onRemoveItem: Function;
  values: any;
  errors: Object;
  onEditItem: any;
  isSubmitting: boolean;
  mode: string;
  item: DailyStep | null;
  authors: Author[];
  dayPlanID: string;
  planID: string;
  planTitle?: string;
  planDescription?: string;
  dayPlanTitle?: string;
  dayPlanDescription?: string;
  authorName?: string;
  authorDescription?: string;
  steps?: DailyStep[];
  user?: { communityId?: string };
};

type State = {
  isSaleConfirmationDialogOpen: boolean;
  shouldBlockFormSubmit: boolean;
  isStepFormDialogVisible: boolean;
  question: Question | null;
  mode: string | null;
  isQuestionFormOpen: boolean;
  isGenerating: boolean;
  audioFiles: AudioFile[];
  loadingAudio: boolean;
  playingAudioUrl: string | null;
  isCombiningAudio: boolean;
  slideWritingStyle: string;
  voiceId: string;
  elevenLabsApiKey: string;
  isGeneratingAudio: boolean;
  audioGenerationProgress: string;
  preserveExistingContent: boolean;
  generateImagesEnabled: boolean;
  generationProgress: string;
};

class DailyStepForm extends Component<Props, State> {
  audioRef: HTMLAudioElement | null = null;

  state = {
    isSaleConfirmationDialogOpen: false,
    shouldBlockFormSubmit: false,
    isStepFormDialogVisible: false,
    question: null,
    mode: "",
    isQuestionFormOpen: false,
    isGenerating: false,
    audioFiles: [] as AudioFile[],
    loadingAudio: false,
    playingAudioUrl: null as string | null,
    isCombiningAudio: false,
    slideWritingStyle: "",
    voiceId: "",
    elevenLabsApiKey: DEFAULT_ELEVENLABS_API_KEY,
    isGeneratingAudio: false,
    audioGenerationProgress: "",
    preserveExistingContent: true,
    generateImagesEnabled: false,
    generationProgress: "",
  };

  componentDidMount() {
    this.loadAudioFiles();
    this.loadSlideWritingStyle();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.item?.id !== this.props.item?.id) {
      this.loadAudioFiles();
    }
    if (prevProps.user?.communityId !== this.props.user?.communityId) {
      this.loadSlideWritingStyle();
    }
  }

  loadSlideWritingStyle = async () => {
    const communityId = this.props.values?.communityId || this.props.user?.communityId;
    console.log("loadSlideWritingStyle communityId:", communityId);
    if (!communityId) return;

    try {
      const doc = await firebase.firestore().collection(DB_PATH.COMMUNITY).doc(communityId).get();
      const data = doc.data();
      console.log("writingStyle from community:", data?.writingStyle);
      console.log("voiceId from community author:", data?.author?.voiceId);
      const communityVoiceId = data?.author?.voiceId || data?.voiceId;
      const updates: Partial<State> = {};
      if (data?.writingStyle) {
        updates.slideWritingStyle = data.writingStyle;
      }
      if (communityVoiceId) {
        updates.voiceId = communityVoiceId;
      }
      if (Object.keys(updates).length) {
        this.setState(updates as any);
      }
    } catch (error) {
      console.error("Error loading community data:", error);
    }
  };

  loadAudioFiles = async () => {
    const LOG = "[LoadAudio]";
    const { item, user } = this.props;
    const communityId = user?.communityId;

    if (!item?.id || !communityId) {
      this.setState({ audioFiles: [], loadingAudio: false });
      return;
    }

    this.setState({ loadingAudio: true });

    const storage = firebase.storage();
    const rootPath = `${DB_PATH.AUDIO}/${communityId}/${item.id}`;
    const rootRef = storage.ref(rootPath);
    const rootPathWithSlash = `${rootPath}/`;

    const collected: AudioFile[] = [];

    const walk = async (
      ref: firebase.storage.Reference
    ): Promise<void> => {
      try {
        const result = await ref.listAll();

        // Recurse into every prefix (voiceId / locale subfolders).
        await Promise.all(result.prefixes.map(walk));

        // Resolve URLs for files at this level.
        const filesAtLevel = await Promise.all(
          result.items.map(async (itemRef) => {
            try {
              const url = await itemRef.getDownloadURL();
              const relativePath = itemRef.fullPath.startsWith(rootPathWithSlash)
                ? itemRef.fullPath.slice(rootPathWithSlash.length)
                : itemRef.name;
              return {
                name: itemRef.name,
                url,
                fullPath: itemRef.fullPath,
                relativePath,
              } as AudioFile;
            } catch (err) {
              console.warn(`${LOG} URL failed for`, itemRef.fullPath, err);
              return null;
            }
          })
        );

        for (const file of filesAtLevel) {
          if (file) collected.push(file);
        }
      } catch (err) {
        console.warn(`${LOG} list failed at`, ref.fullPath, err);
      }
    };

    try {
      console.log(`${LOG} walking`, rootPath);
      await walk(rootRef);

      // Group by folder so admin/top-level files sit together and each
      // voiceId/locale variant is contiguous. Within a group, sort by the
      // numeric position parsed from the filename.
      collected.sort((a, b) => {
        const folderA = (a.relativePath || a.name).replace(/[^/]+$/, "");
        const folderB = (b.relativePath || b.name).replace(/[^/]+$/, "");
        if (folderA !== folderB) return folderA.localeCompare(folderB);
        const numA = parseInt(a.name.replace(/\D/g, ""), 10) || 0;
        const numB = parseInt(b.name.replace(/\D/g, ""), 10) || 0;
        return numA - numB;
      });

      console.log(`${LOG} found ${collected.length} file(s)`);
      this.setState({ audioFiles: collected, loadingAudio: false });
    } catch (error) {
      console.error(`${LOG} failed`, error);
      this.setState({ audioFiles: [], loadingAudio: false });
    }
  };

  playAudio = (url: string) => {
    if (this.audioRef) {
      this.audioRef.pause();
    }

    if (this.state.playingAudioUrl === url) {
      this.setState({ playingAudioUrl: null });
      return;
    }

    this.audioRef = new Audio(url);
    this.audioRef.play();
    this.audioRef.onended = () => {
      this.setState({ playingAudioUrl: null });
    };
    this.setState({ playingAudioUrl: url });
  };

  deleteAudioFile = async (audioFile: AudioFile) => {
    if (!window.confirm(`Delete ${audioFile.name}?`)) return;

    try {
      const storage = firebase.storage();
      await storage.ref(audioFile.fullPath).delete();
      this.setState((prev) => ({
        audioFiles: prev.audioFiles.filter((f) => f.fullPath !== audioFile.fullPath),
      }));
    } catch (error) {
      console.error("Error deleting audio file:", error);
    }
  };

  // Wipes every audio file under this step's storage folder. Used when the
  // text is regenerated — the per-paragraph audio is keyed to the old text
  // and would play out of sync with the new content.
  //
  // Mobile stores audio at nested paths like
  // `Audio/{community}/{step}/{voiceId}/{locale}/{position}.mp3`, so a flat
  // `listAll()` on the step folder misses them. We recurse through every
  // prefix so all variants are cleared.
  private clearStepAudioFiles = async (): Promise<number> => {
    const LOG = "[ClearAudio]";
    const { item, user } = this.props;
    const communityId = user?.communityId;
    const stepId = item?.id;

    if (!stepId || !communityId) {
      console.log(`${LOG} skipped — no stepId or communityId`);
      return 0;
    }

    const storage = firebase.storage();
    const rootPath = `${DB_PATH.AUDIO}/${communityId}/${stepId}`;
    const rootRef = storage.ref(rootPath);

    let deletedCount = 0;

    const deleteRefRecursively = async (
      ref: firebase.storage.Reference
    ): Promise<void> => {
      try {
        const result = await ref.listAll();

        // Recurse into every prefix (subfolder) first.
        await Promise.all(result.prefixes.map(deleteRefRecursively));

        // Then delete all items at this level in parallel.
        if (result.items.length) {
          await Promise.all(
            result.items.map(async (itemRef) => {
              try {
                await itemRef.delete();
                deletedCount += 1;
              } catch (err) {
                console.warn(`${LOG} failed to delete`, itemRef.fullPath, err);
              }
            })
          );
        }
      } catch (err) {
        console.warn(`${LOG} list failed at`, ref.fullPath, err);
      }
    };

    try {
      console.log(`${LOG} walking`, rootPath);
      await deleteRefRecursively(rootRef);

      if (deletedCount > 0) {
        this.setState({ audioFiles: [] });
      }

      console.log(`${LOG} done — deleted ${deletedCount} file(s)`);
      return deletedCount;
    } catch (error) {
      console.error(`${LOG} failed`, error);
      return deletedCount;
    }
  };

  loadScript = (url: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${url}"]`);
      if (existing) {
        resolve();
        return;
      }
      const script = document.createElement("script");
      script.src = url;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${url}`));
      document.head.appendChild(script);
    });
  };

  downloadCombinedAudio = async () => {
    const { audioFiles } = this.state;
    if (audioFiles.length === 0) return;

    if (audioFiles.length === 1) {
      const a = document.createElement("a");
      a.href = audioFiles[0].url;
      a.download = audioFiles[0].name || "audio.mp3";
      a.target = "_blank";
      a.click();
      return;
    }

    this.setState({ isCombiningAudio: true });

    try {
      await this.loadScript("https://cdn.jsdelivr.net/npm/@ffmpeg/ffmpeg@0.11.6/dist/ffmpeg.min.js");

      const { createFFmpeg, fetchFile } = (window as any).FFmpeg;
      const ffmpeg = createFFmpeg({
        log: false,
        corePath: "https://unpkg.com/@ffmpeg/core-st@0.11.1/dist/ffmpeg-core.js",
        mainName: "main",
      });

      if (!ffmpeg.isLoaded()) {
        await ffmpeg.load();
      }

      const inputFiles: string[] = [];
      for (let i = 0; i < audioFiles.length; i++) {
        const response = await fetch(audioFiles[i].url);
        const blob = await response.blob();
        const fileName = `input${i}.mp3`;
        ffmpeg.FS("writeFile", fileName, await fetchFile(blob));
        inputFiles.push(fileName);
      }

      const concatList = inputFiles.map((f) => `file '${f}'`).join("\n");
      ffmpeg.FS("writeFile", "concat.txt", concatList);

      await ffmpeg.run(
        "-f", "concat",
        "-safe", "0",
        "-i", "concat.txt",
        "-c:a", "libmp3lame",
        "-b:a", "192k",
        "-y",
        "combined.mp3"
      );

      const mp3Data = ffmpeg.FS("readFile", "combined.mp3");
      const mp3Blob = new Blob([mp3Data.buffer], { type: "audio/mpeg" });
      const mp3Url = URL.createObjectURL(mp3Blob);

      inputFiles.forEach((f) => ffmpeg.FS("unlink", f));
      ffmpeg.FS("unlink", "concat.txt");
      ffmpeg.FS("unlink", "combined.mp3");

      const a = document.createElement("a");
      a.href = mp3Url;
      a.download = `combined-audio-${Date.now()}.mp3`;
      a.click();

      setTimeout(() => URL.revokeObjectURL(mp3Url), 1000);
    } catch (error) {
      console.error("Error combining audio:", error);
      alert("Could not combine audio files. Please try again.");
    } finally {
      this.setState({ isCombiningAudio: false });
    }
  };

  generateAudioWithElevenLabs = async () => {
    const { voiceId, elevenLabsApiKey } = this.state;
    const textContent = this.props.values?.text || "";
    const communityId = this.props.values?.communityId || this.props.user?.communityId;
    const stepId = this.props.values?.id;
    const trimmedApiKey = (elevenLabsApiKey || "").trim();

    if (!trimmedApiKey) {
      alert("ElevenLabs API key is not configured.");
      return;
    }
    if (!voiceId) {
      alert("No voiceId found for this community's author. Please set it in the community config.");
      return;
    }
    if (!textContent.trim()) {
      alert("No text content to generate audio from. Write or generate content first.");
      return;
    }
    if (!communityId || !stepId) {
      alert("Missing communityId or stepId. Please save the step first.");
      return;
    }

    const paragraphs = textContent.split("\n\n").filter((p: string) => p.trim());
    if (paragraphs.length === 0) {
      alert("No paragraphs found in the text content.");
      return;
    }

    this.setState({ isGeneratingAudio: true, audioGenerationProgress: `Generating audio for ${paragraphs.length} paragraph(s)...` });

    const storage = firebase.storage();

    try {
      for (let i = 0; i < paragraphs.length; i++) {
        const paragraph = paragraphs[i].trim();
        if (!paragraph) continue;

        this.setState({
          audioGenerationProgress: `Generating paragraph ${i + 1} of ${paragraphs.length}...`,
        });

        const response = await fetch(
          `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`,
          {
            method: "POST",
            headers: {
              "xi-api-key": trimmedApiKey,
              "Content-Type": "application/json",
              Accept: "audio/mpeg",
            },
            body: JSON.stringify({
              text: paragraph,
              model_id: "eleven_multilingual_v2",
              voice_settings: {
                stability: 0.5,
                similarity_boost: 0.75,
              },
            }),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`ElevenLabs API error (paragraph ${i + 1}): ${response.status} ${errorText}`);
        }

        const audioBlob = await response.blob();

        this.setState({
          audioGenerationProgress: `Uploading paragraph ${i + 1} of ${paragraphs.length}...`,
        });

        const audioRef = storage.ref(`${DB_PATH.AUDIO}/${communityId}/${stepId}/${i}.mp3`);
        await audioRef.put(audioBlob, { contentType: "audio/mpeg" });
      }

      this.setState({ audioGenerationProgress: "Done! Refreshing audio list..." });
      await this.loadAudioFiles();
    } catch (error) {
      console.error("Error generating audio with ElevenLabs:", error);
      alert(`Audio generation failed: ${(error as Error).message}`);
    } finally {
      this.setState({ isGeneratingAudio: false, audioGenerationProgress: "" });
    }
  };

  handleBlockFormSubmit = (value: boolean): void => {
    this.setState({
      shouldBlockFormSubmit: value,
    });
  };

  renderIndexName = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Title of the Step",
      "Type the title of the step",
      "string",
      "title"
    );
    const isActiveInputField = getRowItemObject(
      "Position",
      "Type the position of the step",
      "string",
      "position"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      isActiveInputField,
      this.props
    );
  };

  renderDescriptions = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Subtitle",
      "Type the subtitle of the step",
      "string",
      "subtitle"
    );
    const descriptionInputFieldData = getRowItemObject(
      "Description",
      "Type the description of the step",
      "string",
      "description"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      descriptionInputFieldData,
      this.props
    );
  };

  renderActionItems = () => {
    const interactiveActionsInputFieldData = getRowItemObject(
      "Action Items",
      "Type the actions items of the step",
      "textarea",
      "interactiveActions"
    );

    return renderRowWithSingleItem(
      interactiveActionsInputFieldData,
      this.props
    );
  };

  onCreateQuestion = (question: Question) => {
    this.props.setFieldValue("questions", [
      ...this.props.values.questions,
      question,
    ]);
    this.onToggleQuestionForm();
  };
  onToggleQuestionForm = (): void => {
    this.setState({
      mode: "create",
      isQuestionFormOpen: !this.state.isQuestionFormOpen,
    });
  };
  onEditQuestions = (step) => {
    const questions = this.props.values.questions;
    const index = Object.values(this.props.values.questions).findIndex(
      //@ts-ignore
      (step) => step.id === this.state.question.id
    );

    questions[index] = step;
    this.props.setFieldValue("questions", questions);
    this.onToggleQuestionForm();
  };

  onEditIconClicked = (question: Question): void => {
    this.setState({
      isQuestionFormOpen: true,
      mode: "edit",
      question,
    });
  };

  onRemoveQuestion = (question: Question) => {
    const prevQuestions: Question[] = this.props.values["questions"];

    const newQuestions = Object.values(prevQuestions).filter(
      (_question) => _question.id !== question.id
    );

    this.props.setFieldValue("questions", newQuestions);
  };

  // Builds the clickable "Insert" chips shown in the Main Content toolbar from
  // the resources actually attached to this step. Clicking a chip drops the
  // matching marker (<video#1>, <image#2>, <list#1>, <callout#1>, ...) at the
  // cursor so authors never have to type the tag syntax by hand.
  private buildContentTags = (): InsertableTag[] => {
    const { values } = this.props;
    const videos = Array.isArray(values?.videos) ? values.videos : [];
    const images = Array.isArray(values?.images) ? values.images : [];
    const lists = Array.isArray(values?.lists) ? values.lists : [];
    const callouts = Array.isArray(values?.callouts) ? values.callouts : [];

    const tags: InsertableTag[] = [];

    videos.forEach((_video: any, i: number) =>
      tags.push({ label: `Video ${i + 1}`, tag: `<video#${i + 1}>` })
    );
    images.forEach((_image: any, i: number) =>
      tags.push({ label: `Image ${i + 1}`, tag: `<image#${i + 1}>` })
    );
    lists.forEach((list: any, i: number) =>
      tags.push({
        label: list?.title?.trim()
          ? `List: ${list.title.trim()}`
          : `List ${i + 1}`,
        tag: `<list#${i + 1}>`,
      })
    );
    callouts.forEach((callout: any, i: number) => {
      const tone =
        typeof callout?.tone === "string" ? callout.tone.trim() : "";
      const toneLabel = tone
        ? `${tone.charAt(0).toUpperCase()}${tone.slice(1)} callout`
        : `Callout ${i + 1}`;
      tags.push({
        label: callout?.title?.trim()
          ? `Callout: ${callout.title.trim()}`
          : toneLabel,
        tag: `<callout#${i + 1}>`,
      });
    });

    return tags;
  };

  renderTexts = () => {
    const isSaleActiveInputFieldData = {
      ...getRowItemObject(
        "Main Content",
        "Type the content title of the step",
        "textarea",
        "text"
      ),
      insertableTags: this.buildContentTags(),
    };

    return (
      <div>
        {renderRowWithSingleItem(isSaleActiveInputFieldData, this.props)}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "var(--space-3)",
            marginTop: "var(--space-2)",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "var(--space-2)",
              fontSize: "var(--font-size-sm)",
              color: "var(--color-text-secondary)",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={this.state.preserveExistingContent}
              onChange={(e) =>
                this.setState({ preserveExistingContent: e.target.checked })
              }
              disabled={this.state.isGenerating}
            />
            Preserve existing content
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "var(--space-2)",
              fontSize: "var(--font-size-sm)",
              color: "var(--color-text-secondary)",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={this.state.generateImagesEnabled}
              onChange={(e) =>
                this.setState({ generateImagesEnabled: e.target.checked })
              }
              disabled={this.state.isGenerating}
            />
            Generate images
          </label>
          <Button
            variant="ai"
            size="md"
            onClick={this.generateStepContent}
            isLoading={this.state.isGenerating}
            disabled={this.state.isGenerating}
          >
            Generate rich content
          </Button>
        </div>
        {this.state.generationProgress && (
          <ProgressHint style={{ textAlign: "right" }}>
            {this.state.generationProgress}
          </ProgressHint>
        )}
      </div>
    );
  };
  renderQuote = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Quote",
      "Type the quote of the step",
      "textarea",
      "quote"
    );
    const isSaleActiveInputFieldData = getRowItemObject(
      "Reference",
      "Type the reference of the content",
      "textarea",
      "reference"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      isSaleActiveInputFieldData,
      this.props
    );
  };
  renderExperienceReward = () => {
    const experienceRewardInputFieldData = getRowItemObject(
      "Experience Reward",
      "Type the experience reward of the step",
      "textarea",
      "xpReward"
    );

    return renderRowWithSingleItem(experienceRewardInputFieldData, this.props);
  };
  renderArtifactPrompt = () => {
    const { values, setFieldValue } = this.props;
    const artifactPrompt = values.artifactPrompt;
    const enabled = artifactPrompt?.enabled === true;
    const kind = artifactPrompt?.recommendedKind || "diagnostic";

    const setEnabled = (nextEnabled: boolean) => {
      if (!nextEnabled) {
        setFieldValue("artifactPrompt", undefined);
        return;
      }

      setFieldValue("artifactPrompt", {
        enabled: true,
        recommendedKind: kind,
        allowedKinds: [kind],
        ctaLabel: artifactPrompt?.ctaLabel || "",
      });
    };

    const setKind = (nextKind: string) => {
      setFieldValue("artifactPrompt", {
        ...artifactPrompt,
        enabled: true,
        recommendedKind: nextKind,
        allowedKinds: [nextKind],
      });
    };

    return (
      <Section>
        <SectionH4>Interactive artifact</SectionH4>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--space-2)",
            fontSize: "var(--font-size-sm)",
            color: "var(--color-text-secondary)",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={enabled}
            onChange={(event) => setEnabled(event.target.checked)}
          />
          Let members create an artifact from this lesson
        </label>
        <FieldHint>
          Enable this only when the lesson naturally produces a useful,
          reusable result. Good fits are assessments, actionable checklists,
          and choices that benefit from comparing options.
        </FieldHint>
        {enabled && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(180px, 240px) minmax(220px, 1fr)",
              gap: "var(--space-3)",
              marginTop: "var(--space-3)",
            }}
          >
            <label>
              <FieldHint style={{ marginTop: 0, marginBottom: "var(--space-2)" }}>
                Artifact type
              </FieldHint>
              <select
                value={kind}
                onChange={(event) => setKind(event.target.value)}
                style={{
                  width: "100%",
                  height: 36,
                  padding: "0 var(--space-3)",
                  background: "var(--color-surface)",
                  border: "1px solid var(--color-border)",
                  borderRadius: "var(--radius-sm)",
                  color: "var(--color-text)",
                }}
              >
                <option value="diagnostic">Diagnostic</option>
                <option value="checklist">Checklist</option>
                <option value="decision_matrix">Decision matrix</option>
              </select>
            </label>
            <label>
              <FieldHint style={{ marginTop: 0, marginBottom: "var(--space-2)" }}>
                Button label (optional)
              </FieldHint>
              <SmallTextInput
                type="text"
                placeholder="Create my assessment"
                value={artifactPrompt?.ctaLabel || ""}
                onChange={(event) =>
                  setFieldValue("artifactPrompt", {
                    ...artifactPrompt,
                    enabled: true,
                    recommendedKind: kind,
                    allowedKinds: [kind],
                    ctaLabel: event.target.value,
                  })
                }
              />
            </label>
          </div>
        )}
      </Section>
    );
  };
  renderQuestionsTable = ({}: any): Object => {
    return (
      <Section>
        <ButtonWrapper>
          <ActionButton
            action={this.onToggleQuestionForm}
            disabled={false}
            withIcon
            title={"New Question"}
          />
        </ButtonWrapper>
        <Table
          currentPage={0}
          updatePageIndex={() => {}}
          onEditIconClicked={this.onEditIconClicked}
          onRemoveIconClicked={(question) => this.onRemoveQuestion(question)}
          tabConfig={questionTabConfig}
          dataset={Object.values(this.props.values.questions)}
          canBeRemoved
          canBeEdited
        />
      </Section>
    );
  };
  renderAudioFiles = () => {
    const {
      audioFiles,
      loadingAudio,
      playingAudioUrl,
      isCombiningAudio,
      isGeneratingAudio,
      audioGenerationProgress,
      elevenLabsApiKey,
    } = this.state;
    const textContent = this.props.values?.text || "";

    return (
      <Section>
        <SectionH4>Audio files</SectionH4>
        {loadingAudio ? (
          <EmptyHint>Loading audio files...</EmptyHint>
        ) : audioFiles.length === 0 ? (
          <EmptyHint>No audio files found for this step.</EmptyHint>
        ) : (
          <div>
            {audioFiles.map((audio) => (
              <AudioRow key={audio.fullPath}>
                <Button
                  variant={playingAudioUrl === audio.url ? "primary" : "secondary"}
                  size="sm"
                  onClick={() => this.playAudio(audio.url)}
                >
                  {playingAudioUrl === audio.url ? "Pause" : "Play"}
                </Button>
                <AudioName>{audio.relativePath || audio.name}</AudioName>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    const a = document.createElement("a");
                    a.href = audio.url;
                    a.download = audio.name || "audio.mp3";
                    a.target = "_blank";
                    a.click();
                  }}
                >
                  Download
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => this.deleteAudioFile(audio)}
                >
                  Delete
                </Button>
              </AudioRow>
            ))}
          </div>
        )}
        <div style={{ marginTop: "var(--space-3)", display: "flex", gap: "var(--space-2)", flexWrap: "wrap", alignItems: "center" }}>
          <SmallTextInput
            type="password"
            placeholder="ElevenLabs API Key"
            value={elevenLabsApiKey}
            onChange={(e) => this.setState({ elevenLabsApiKey: e.target.value })}
            style={{ minWidth: 260, flex: "0 0 260px", height: 36 }}
          />
          <Button
            variant="ai"
            size="md"
            onClick={this.generateAudioWithElevenLabs}
            isLoading={isGeneratingAudio}
            disabled={isGeneratingAudio || !textContent.trim()}
          >
            Generate audio
          </Button>
          <Button
            variant="secondary"
            size="md"
            onClick={this.downloadCombinedAudio}
            isLoading={isCombiningAudio}
            disabled={loadingAudio || audioFiles.length === 0 || isCombiningAudio}
          >
            {audioFiles.length > 1 ? "Download combined" : "Download audio"}
          </Button>
          <Button variant="ghost" size="md" onClick={this.loadAudioFiles}>
            Refresh
          </Button>
        </div>
        {!!audioGenerationProgress && (
          <ProgressHint>{audioGenerationProgress}</ProgressHint>
        )}
      </Section>
    );
  };

  renderImageResources = () => {
    const { values, setFieldValue } = this.props;
    const images = values.images || [];

    const onUpload = async (file: File) => {
      const stepID = values.id || "temp";
      const communityId = values.communityId || "common";
      const url = (
        await uploadMedia({
          body: file,
          kind: "image",
          fileName: file.name,
          firebasePath:
            `${DB_PATH.IMAGES}/${communityId}/${stepID}/${file.name}`,
        })
      ).url;

      const next = [
        ...images,
        { id: `${images.length + 1}`, url, alt: "", caption: "" },
      ];
      setFieldValue("images", next);
    };

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) onUpload(file);
    };

    const onChangeField = (idx: number, key: "alt" | "caption", v: string) => {
      const next = images.slice();
      next[idx] = { ...next[idx], [key]: v };
      setFieldValue("images", next);
    };

    const onRemove = (idx: number) => {
      void deleteMedia({ url: images[idx]?.url }).catch((error) =>
        console.warn("Could not delete image media:", error)
      );
      const next = images.filter((_, i) => i !== idx);
      setFieldValue("images", next);
    };

    return (
      <Section>
        <SectionH4>Image resources</SectionH4>
        <div style={{ marginBottom: "var(--space-3)" }}>
          <FileInputLabel>
            <FileInputIcon />
            Upload image
            <input type="file" accept="image/*" onChange={onFileChange} />
          </FileInputLabel>
          <FieldHint>
            Insert in content with tags like <code>{`<image#1>`}</code>, where
            #1 → first image.
          </FieldHint>
        </div>

        {images.length > 0 && (
          <div>
            {images.map((img, i) => (
              <ImageRow key={img.id || i}>
                <ImageThumb src={img.url} alt={img.alt || ""} />
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
                  <FieldHint style={{ marginTop: 0 }}>
                    Tag: <code>{`<image#${i + 1}>`}</code>
                  </FieldHint>
                  <SmallTextInput
                    type="text"
                    placeholder="Alt text"
                    value={img.alt || ""}
                    onChange={(e) => onChangeField(i, "alt", e.target.value)}
                  />
                  <SmallTextInput
                    type="text"
                    placeholder="Caption (optional)"
                    value={img.caption || ""}
                    onChange={(e) =>
                      onChangeField(i, "caption", e.target.value)
                    }
                  />
                </div>
                <Button variant="danger" size="sm" onClick={() => onRemove(i)}>
                  Remove
                </Button>
              </ImageRow>
            ))}
          </div>
        )}
      </Section>
    );
  };

  renderVideoResources = () => {
    const { values, setFieldValue } = this.props;
    const videos = values.videos || [];

    const onUpload = async (file: File) => {
      const stepID = values.id || "temp";
      const communityId = values.communityId || "common";
      const url = (
        await uploadMedia({
          body: file,
          kind: "video",
          fileName: file.name,
          firebasePath:
            `${DB_PATH.VIDEO}/${communityId}/${stepID}/${file.name}`,
        })
      ).url;

      const next = [
        ...videos,
        { id: `${videos.length + 1}`, url, alt: "", caption: "" },
      ];
      setFieldValue("videos", next);
    };

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) onUpload(file);
    };

    const onChangeField = (
      idx: number,
      key: "alt" | "caption" | "url",
      v: string
    ) => {
      const next = videos.slice();
      next[idx] = { ...next[idx], [key]: v };
      setFieldValue("videos", next);
    };

    const onAddURL = () => {
      const next = [
        ...videos,
        { id: `${videos.length + 1}`, url: "", alt: "", caption: "" },
      ];
      setFieldValue("videos", next);
    };

    const onRemove = (idx: number) => {
      void deleteMedia({ url: videos[idx]?.url }).catch((error) =>
        console.warn("Could not delete video media:", error)
      );
      const next = videos.filter((_, i) => i !== idx);
      setFieldValue("videos", next);
    };

    const isYouTube = (url: string) =>
      /(?:youtube\.com|youtu\.be)/i.test(url || "");
    const youTubeId = (url: string) => {
      const m = (url || "").match(
        /(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
      );
      return m ? m[1] : null;
    };

    return (
      <Section>
        <SectionH4>Video resources</SectionH4>
        <div style={{ marginBottom: "var(--space-3)", display: "flex", gap: "var(--space-2)", alignItems: "center", flexWrap: "wrap" }}>
          <FileInputLabel>
            <FileInputIcon />
            Upload video
            <input type="file" accept="video/*" onChange={onFileChange} />
          </FileInputLabel>
          <Button variant="ghost" size="sm" onClick={onAddURL}>
            Add YouTube / video URL
          </Button>
          <FieldHint style={{ flexBasis: "100%" }}>
            Upload a file or paste a YouTube link. Insert in content with tags
            like <code>{`<video#1>`}</code>, where #1 → first video.
          </FieldHint>
        </div>

        {videos.length > 0 && (
          <div>
            {videos.map((vid, i) => (
              <ImageRow key={vid.id || i}>
                {isYouTube(vid.url) ? (
                  youTubeId(vid.url) ? (
                    <iframe
                      title={`video-${i}`}
                      src={`https://www.youtube.com/embed/${youTubeId(vid.url)}`}
                      style={{ width: 160, height: 90, border: 0, borderRadius: "var(--radius-md)" }}
                      allowFullScreen
                    />
                  ) : (
                    <div style={{ width: 160, height: 90, display: "flex", alignItems: "center", justifyContent: "center", background: "#000", color: "#fff", borderRadius: "var(--radius-md)", fontSize: "var(--font-size-sm)" }}>
                      Invalid URL
                    </div>
                  )
                ) : (
                  <video
                    src={vid.url}
                    controls
                    style={{ width: 160, borderRadius: "var(--radius-md)", background: "#000" }}
                  />
                )}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
                  <SmallTextInput
                    type="text"
                    placeholder="Video URL (YouTube or direct link)"
                    value={vid.url || ""}
                    onChange={(e) => onChangeField(i, "url", e.target.value)}
                  />
                  <FieldHint style={{ marginTop: 0 }}>
                    Tag: <code>{`<video#${i + 1}>`}</code>
                  </FieldHint>
                  <SmallTextInput
                    type="text"
                    placeholder="Alt text"
                    value={vid.alt || ""}
                    onChange={(e) => onChangeField(i, "alt", e.target.value)}
                  />
                  <SmallTextInput
                    type="text"
                    placeholder="Caption (optional)"
                    value={vid.caption || ""}
                    onChange={(e) =>
                      onChangeField(i, "caption", e.target.value)
                    }
                  />
                </div>
                <Button variant="danger" size="sm" onClick={() => onRemove(i)}>
                  Remove
                </Button>
              </ImageRow>
            ))}
          </div>
        )}
      </Section>
    );
  };

  renderLists = () => {
    const { values, setFieldValue } = this.props;
    const lists = values.lists || [];

    const addList = () => {
      const next = [
        ...lists,
        { id: String(lists.length + 1), title: "", ordered: false, items: [""] },
      ];
      setFieldValue("lists", next);
    };

    const updateList = (idx: number, patch: Partial<typeof lists[number]>) => {
      const next = lists.slice();
      next[idx] = { ...next[idx], ...patch };
      setFieldValue("lists", next);
    };

    const removeList = (idx: number) => {
      setFieldValue(
        "lists",
        lists.filter((_, i) => i !== idx)
      );
    };

    const updateItem = (listIdx: number, itemIdx: number, value: string) => {
      const next = lists.slice();
      const items = (next[listIdx].items || []).slice();
      items[itemIdx] = value;
      next[listIdx] = { ...next[listIdx], items };
      setFieldValue("lists", next);
    };

    const addItem = (listIdx: number) => {
      const next = lists.slice();
      next[listIdx] = { ...next[listIdx], items: [...(next[listIdx].items || []), ""] };
      setFieldValue("lists", next);
    };

    const removeItem = (listIdx: number, itemIdx: number) => {
      const next = lists.slice();
      next[listIdx] = {
        ...next[listIdx],
        items: (next[listIdx].items || []).filter((_, i) => i !== itemIdx),
      };
      setFieldValue("lists", next);
    };

    return (
      <Section>
        <SectionH4>Lists</SectionH4>
        <FieldHint style={{ marginBottom: "var(--space-3)" }}>
          Insert in content with tags like <code>{`<list#1>`}</code>, where #1 → first list.
        </FieldHint>

        {lists.map((list, i) => (
          <ImageRow key={list.id || i} style={{ flexDirection: "column", alignItems: "stretch" }}>
            <FieldHint style={{ marginTop: 0 }}>
              Tag: <code>{`<list#${i + 1}>`}</code>
            </FieldHint>
            <SmallTextInput
              type="text"
              placeholder="List title (optional)"
              value={list.title || ""}
              onChange={(e) => updateList(i, { title: e.target.value })}
            />
            <label style={{ display: "flex", alignItems: "center", gap: "var(--space-2)", fontSize: "var(--font-size-sm)", color: "var(--color-text-secondary)" }}>
              <input
                type="checkbox"
                checked={!!list.ordered}
                onChange={(e) => updateList(i, { ordered: e.target.checked })}
              />
              Numbered list
            </label>
            {(list.items || []).map((item, j) => (
              <div key={j} style={{ display: "flex", gap: "var(--space-2)" }}>
                <SmallTextInput
                  type="text"
                  placeholder={`Item ${j + 1}`}
                  value={item}
                  onChange={(e) => updateItem(i, j, e.target.value)}
                />
                <Button variant="danger" size="sm" onClick={() => removeItem(i, j)}>
                  Remove
                </Button>
              </div>
            ))}
            <div style={{ display: "flex", gap: "var(--space-2)" }}>
              <Button variant="ghost" size="sm" onClick={() => addItem(i)}>
                Add item
              </Button>
              <Button variant="danger" size="sm" onClick={() => removeList(i)}>
                Remove list
              </Button>
            </div>
          </ImageRow>
        ))}

        <Button variant="ghost" size="sm" onClick={addList}>
          Add list
        </Button>
      </Section>
    );
  };

  renderCallouts = () => {
    const { values, setFieldValue } = this.props;
    const callouts = values.callouts || [];

    const addCallout = () => {
      setFieldValue("callouts", [
        ...callouts,
        { id: String(callouts.length + 1), tone: "info", title: "", text: "" },
      ]);
    };

    const updateCallout = (idx: number, patch: Partial<typeof callouts[number]>) => {
      const next = callouts.slice();
      next[idx] = { ...next[idx], ...patch };
      setFieldValue("callouts", next);
    };

    const removeCallout = (idx: number) => {
      setFieldValue(
        "callouts",
        callouts.filter((_, i) => i !== idx)
      );
    };

    return (
      <Section>
        <SectionH4>Callouts</SectionH4>
        <FieldHint style={{ marginBottom: "var(--space-3)" }}>
          Insert in content with tags like <code>{`<callout#1>`}</code>, where #1 → first callout.
        </FieldHint>

        {callouts.map((callout, i) => (
          <ImageRow key={callout.id || i} style={{ flexDirection: "column", alignItems: "stretch" }}>
            <FieldHint style={{ marginTop: 0 }}>
              Tag: <code>{`<callout#${i + 1}>`}</code>
            </FieldHint>
            <div style={{ display: "flex", gap: "var(--space-2)" }}>
              <select
                value={callout.tone || "info"}
                onChange={(e) => updateCallout(i, { tone: e.target.value as any })}
                style={{ flex: "0 0 140px" }}
              >
                <option value="info">Info</option>
                <option value="tip">Tip</option>
                <option value="warning">Warning</option>
                <option value="note">Note</option>
              </select>
              <SmallTextInput
                type="text"
                placeholder="Title (optional)"
                value={callout.title || ""}
                onChange={(e) => updateCallout(i, { title: e.target.value })}
              />
            </div>
            <textarea
              placeholder="Callout text"
              value={callout.text || ""}
              onChange={(e) => updateCallout(i, { text: e.target.value })}
              rows={3}
              style={{
                width: "100%",
                padding: "var(--space-2) var(--space-3)",
                background: "var(--color-surface)",
                border: "1px solid var(--color-border)",
                borderRadius: "var(--radius-sm)",
                fontFamily: "var(--font-sans)",
                fontSize: "var(--font-size-sm)",
                color: "var(--color-text)",
                resize: "vertical",
              }}
            />
            <Button variant="danger" size="sm" onClick={() => removeCallout(i)}>
              Remove callout
            </Button>
          </ImageRow>
        ))}

        <Button variant="ghost" size="sm" onClick={addCallout}>
          Add callout
        </Button>
      </Section>
    );
  };

  renderCtas = () => {
    const { values, setFieldValue, errors } = this.props;
    const ctas: StepCta[] = Array.isArray(values.ctas) ? values.ctas : [];
    const ctaErrors: any[] = Array.isArray((errors as any)?.ctas)
      ? (errors as any).ctas
      : [];
    const listError =
      typeof (errors as any)?.ctas === "string" ? (errors as any).ctas : "";

    const addCta = () => {
      if (ctas.length >= MAX_CTAS) return;
      setFieldValue("ctas", [
        ...ctas,
        { id: Math.random().toString(36).slice(2, 10), label: "", url: "" },
      ]);
    };

    const updateCta = (idx: number, patch: Partial<StepCta>) => {
      const next = ctas.slice();
      next[idx] = { ...next[idx], ...patch };
      setFieldValue("ctas", next);
    };

    const removeCta = (idx: number) => {
      setFieldValue(
        "ctas",
        ctas.filter((_, i) => i !== idx)
      );
    };

    return (
      <Section>
        <SectionH4>Buttons</SectionH4>
        <FieldHint style={{ marginBottom: "var(--space-3)" }}>
          Up to {MAX_CTAS} link buttons shown under the step text in the app, in
          this order. The first one is the main button. Links must start with{" "}
          <code>https://</code>.
        </FieldHint>

        {ctas.map((cta, i) => (
          <ImageRow key={cta.id || i} style={{ flexDirection: "column", alignItems: "stretch" }}>
            <div style={{ display: "flex", gap: "var(--space-2)" }}>
              <SmallTextInput
                type="text"
                placeholder="Button label"
                maxLength={MAX_CTA_LABEL}
                value={cta.label || ""}
                onChange={(e) => updateCta(i, { label: e.target.value })}
                style={{ flex: "0 0 35%" }}
              />
              <SmallTextInput
                type="url"
                placeholder="https://..."
                value={cta.url || ""}
                onChange={(e) => updateCta(i, { url: e.target.value })}
              />
              <Button variant="danger" size="sm" onClick={() => removeCta(i)}>
                Remove
              </Button>
            </div>
            {(ctaErrors[i]?.label || ctaErrors[i]?.url) && (
              <FieldHint style={{ marginTop: 0, color: "var(--color-danger)" }}>
                {ctaErrors[i]?.label || ctaErrors[i]?.url}
              </FieldHint>
            )}
          </ImageRow>
        ))}

        {listError && (
          <FieldHint style={{ color: "var(--color-danger)" }}>{listError}</FieldHint>
        )}

        {ctas.length < MAX_CTAS && (
          <Button variant="ghost" size="sm" onClick={addCta}>
            Add button
          </Button>
        )}
      </Section>
    );
  };

  renderVideoUpload = () => {
    const { values, setFieldValue } = this.props;
    const videoURL = values.videoURL || "";

    const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const stepID = values.id || "temp";
      const communityId = values.communityId || "common";
      const url = (
        await uploadMedia({
          body: file,
          kind: "video",
          fileName: file.name,
          firebasePath:
            `${DB_PATH.VIDEO}/${communityId}/${stepID}/${file.name}`,
        })
      ).url;
      setFieldValue("videoURL", url);
    };

    const onRemove = () => {
      void deleteMedia({ url: videoURL }).catch((error) =>
        console.warn("Could not delete video media:", error)
      );
      setFieldValue("videoURL", "");
    };

    return (
      <Section>
        <SectionH4>Video</SectionH4>
        <div style={{ marginBottom: "var(--space-3)" }}>
          <FileInputLabel>
            <FileInputIcon />
            Upload video
            <input type="file" accept="video/*" onChange={onFileChange} />
          </FileInputLabel>
        </div>
        {videoURL && (
          <div style={{ display: "flex", alignItems: "flex-start", gap: "var(--space-3)" }}>
            <video
              src={videoURL}
              controls
              style={{ maxWidth: 320, borderRadius: "var(--radius-md)" }}
            />
            <Button variant="danger" size="sm" onClick={onRemove}>
              Remove
            </Button>
          </div>
        )}
      </Section>
    );
  };

  renderQuestionForm = (): any => {
    return (
      <FullScreenDialog
        onClose={this.onToggleQuestionForm}
        isOpen={this.state.isQuestionFormOpen}
        title={"Questions"}
      >
        <QuestionForm
          onToggleFullScreenDialog={this.onToggleQuestionForm}
          onRemoveItem={this.onRemoveQuestion}
          onCreateItem={this.onCreateQuestion}
          onEditItem={this.onEditQuestions}
          item={this.state.question}
          mode={this.state.mode}
        />
      </FullScreenDialog>
    );
  };
  renderSaveButton = () => {
    return (
      <ActionFormButton
        onClick={() => this.props.handleSubmit()}
        disabled={false}
        entity="Plan"
        canBeRemoved
        mode={"edit"}
      />
    );
  };

  renderDayPlan = (): Object => {
    return (
      <Section>
        {this.renderIndexName()}
        {this.renderDescriptions()}
        {this.renderTexts()}
        {this.renderQuote()}
        {this.renderQuestionForm()}
        {this.renderActionItems()}
        {this.renderArtifactPrompt()}
        {this.renderImageResources()}
        {this.renderVideoResources()}
        {this.renderLists()}
        {this.renderCallouts()}
        {this.renderCtas()}
        {this.renderVideoUpload()}
        {this.renderAudioFiles()}
        {this.renderQuestionsTable(this.props)}
        {this.renderSaveButton()}
      </Section>
    );
  };

  render() {
    return <Wrapper>{this.renderDayPlan()}</Wrapper>;
  }

  private buildPrompt = () => {
    const {
      planTitle = "",
      planDescription = "",
      dayPlanTitle = "",
      dayPlanDescription = "",
      authorName = "",
      authorDescription = "",
      values,
      steps = [],
    } = this.props;

    const { slideWritingStyle, preserveExistingContent, generateImagesEnabled } =
      this.state;

    const stepTitle = values?.title || "";
    const stepDescription = values?.description || "";
    const stepSubtitle = values?.subtitle || "";
    const stepText = values?.text || "";
    const stepReference = values?.reference || "";
    const existingLists = Array.isArray(values?.lists) ? values.lists : [];
    const existingCallouts = Array.isArray(values?.callouts) ? values.callouts : [];

    const currentId = values?.id;
    const currentPos =
      typeof values?.position === "number"
        ? values.position
        : Number(values?.position) || undefined;

    const sortedSteps = Array.isArray(steps)
      ? [...steps].sort(
          (a, b) => (a.position || 0) - (b.position || 0)
        )
      : [];

    let previousStep = null;
    let nextStep = null;

    if (sortedSteps.length) {
      const idx = sortedSteps.findIndex((s) => s.id === currentId);

      if (idx !== -1) {
        previousStep = sortedSteps[idx - 1] || null;
        nextStep = sortedSteps[idx + 1] || null;
      } else if (currentPos !== undefined) {
        previousStep = [...sortedSteps]
          .filter((s) => typeof s.position === "number" && s.position < currentPos)
          .pop() || null;
        nextStep =
          [...sortedSteps].find(
            (s) => typeof s.position === "number" && s.position > currentPos
          ) || null;
      }
    }

    const neighborContext = [
      previousStep
        ? `- Previous step (${previousStep.position || "n/a"}): ${previousStep.title || ""}`
        : null,
      nextStep
        ? `- Next step (${nextStep.position || "n/a"}): ${nextStep.title || ""}`
        : null,
    ]
      .filter(Boolean)
      .join("\n");

    const writingStyleNote = slideWritingStyle?.trim()
      ? `Writing style/tone to follow: ${slideWritingStyle.trim()}`
      : "";

    const existingMaterial = preserveExistingContent
      ? `EXISTING STEP CONTENT (preserve wherever practical; do not rewrite for the sake of rewriting):
${stepText ? `--- TEXT ---\n${stepText}\n` : "(no existing text)"}
${existingLists.length ? `--- LISTS ---\n${JSON.stringify(existingLists, null, 2)}\n` : ""}${existingCallouts.length ? `--- CALLOUTS ---\n${JSON.stringify(existingCallouts, null, 2)}\n` : ""}`
      : `Generate fresh content from scratch using the metadata below. Do not reuse any existing wording.`;

    const preserveDirective = preserveExistingContent
      ? `PRIMARY DIRECTIVE: Preserve the existing content above. Reuse its wording, examples, numbers, and dosages verbatim wherever practical. Restructure only to fit the article format — extract any inline lists into the "lists" array, extract any inline emphasized notes/tips/warnings into the "callouts" array, and leave the prose itself intact.`
      : `PRIMARY DIRECTIVE: Write fresh, rich step content from scratch based on the metadata. Match the author's voice.`;

    return `
You are writing one step of a long-form learning plan rendered in an article reader (paragraphs + bulleted/numbered lists + colored callout cards).

${preserveDirective}

Voice & tone:
- Write in the voice of ${authorName || "the author"}.
- Be direct, specific, and concrete; avoid coach-bot or therapy-speak filler.
- Avoid stock phrases like "journey," "unlock," "dive in," "explore."
${writingStyleNote ? `- ${writingStyleNote}` : ""}

Output format — return ONLY valid JSON, no markdown, no extra text:
{
  "text": "Step prose, paragraphs separated by \\n\\n, with <list#N>, <callout#N>, and <image#N> markers placed inline where each block belongs in the reading flow",
  "lists": [
    {
      "id": "1",
      "title": "Optional heading shown above the list",
      "ordered": false,
      "items": ["Item one", "Item two"]
    }
  ],
  "callouts": [
    {
      "id": "1",
      "tone": "tip",
      "title": "Optional short label",
      "text": "The callout body"
    }
  ]${generateImagesEnabled ? `,
  "images": [
    {
      "id": "1",
      "prompt": "Self-contained visual description for an image generator — describe the subject, composition, style, lighting, mood. No text in the image. Be specific.",
      "alt": "Short alt text for accessibility",
      "caption": "Optional short caption shown under the image"
    }
  ]` : ""}
}

Rules:
- "lists" and "callouts" must be arrays. Use empty arrays if none are needed.
- IDs inside this step are unique and start at "1".
- Each "<list#N>" / "<callout#N>"${generateImagesEnabled ? ` / "<image#N>"` : ""} marker in "text" must sit on its own line, separated from surrounding paragraphs by "\\n\\n".
- Allowed callout tones: "info", "warning", "tip", "note". Omit "tone" if none clearly fits.
- Do NOT inline lists as prose inside "text" (use the "lists" array + marker).
- Do NOT inline emphasized notes/warnings/tips as prose (use the "callouts" array + marker).${generateImagesEnabled ? `
- Propose 1-3 images only when a visual genuinely aids understanding. Return an empty "images" array when nothing visual would help.
- Image prompts must NOT request any text, letters, words, numbers, watermarks, or typography in the rendered image.
- Image style should match the subject: photographic for lifestyle/people, clean illustration/diagram for concepts. Avoid generic stock-photo language.` : ""}

Background context (for accuracy only — do not reference explicitly):
- Author description: ${authorDescription || "No author description provided"}
- Step title: ${stepTitle}
- Step subtitle: ${stepSubtitle}
- Step description: ${stepDescription}
- Broader theme: ${planTitle}
- Plan description: ${planDescription}
- Day plan title: ${dayPlanTitle}
- Day plan description: ${dayPlanDescription}
${stepReference ? `- Source reference: ${stepReference}` : ""}

${neighborContext ? `Continuity context (do not mention):\n${neighborContext}` : ""}

${existingMaterial}
`;
  };

  private normalizeGeneratedLists = (raw: unknown): any[] => {
    if (!Array.isArray(raw)) return [];
    return raw
      .map((entry: any, index: number) => {
        const items = Array.isArray(entry?.items)
          ? entry.items
              .map((item: any) =>
                typeof item === "string" ? item.trim() : ""
              )
              .filter(Boolean)
          : [];
        if (!items.length) return null;
        return {
          id:
            typeof entry?.id === "string" && entry.id.trim()
              ? entry.id.trim()
              : String(index + 1),
          ...(typeof entry?.title === "string" && entry.title.trim()
            ? { title: entry.title.trim() }
            : {}),
          ...(entry?.ordered === true ? { ordered: true } : {}),
          items,
        };
      })
      .filter(Boolean) as any[];
  };

  private normalizeGeneratedCallouts = (raw: unknown): any[] => {
    if (!Array.isArray(raw)) return [];
    const tones = ["info", "warning", "tip", "note"];
    return raw
      .map((entry: any, index: number) => {
        const text = typeof entry?.text === "string" ? entry.text.trim() : "";
        if (!text) return null;
        const rawTone =
          typeof entry?.tone === "string" ? entry.tone.trim().toLowerCase() : "";
        const tone = tones.includes(rawTone) ? rawTone : undefined;
        return {
          id:
            typeof entry?.id === "string" && entry.id.trim()
              ? entry.id.trim()
              : String(index + 1),
          ...(tone ? { tone } : {}),
          ...(typeof entry?.title === "string" && entry.title.trim()
            ? { title: entry.title.trim() }
            : {}),
          text,
        };
      })
      .filter(Boolean) as any[];
  };

  private generateStepContent = async () => {
    const LOG = "[GenerateStep]";
    const prompt = this.buildPrompt();
    // Backend logs show gpt-5-mini on this prompt typically takes 60-90s,
    // with a long tail up to ~175s. Cloud Function cap is 300s.
    // Local cap at 240s so we never beat the backend to the punch.
    const TEXT_TIMEOUT_MS = 240000;

    const startedAt = Date.now();
    let ticker: ReturnType<typeof setInterval> | null = null;

    const setElapsed = (label: string) => {
      const elapsed = Math.round((Date.now() - startedAt) / 1000);
      this.setState({ generationProgress: `${label} (${elapsed}s elapsed)` });
    };

    console.log(`${LOG} start`, {
      preserveExistingContent: this.state.preserveExistingContent,
      generateImagesEnabled: this.state.generateImagesEnabled,
      promptLength: prompt.length,
      stepId: this.props.values?.id,
      stepTitle: this.props.values?.title,
    });
    console.debug(`${LOG} full prompt`, prompt);

    this.setState({ isGenerating: true });
    setElapsed("Generating text, lists, and callouts...");
    ticker = setInterval(
      () => setElapsed("Generating text, lists, and callouts..."),
      2000
    );

    try {
      console.log(`${LOG} dispatching createOpenAIChatCompletion`, {
        model: "gpt-5-mini",
        max_completion_tokens: 4000,
        timeoutMs: TEXT_TIMEOUT_MS,
      });

      // Belt-and-braces: race the call against a local timeout so a hung
      // Firebase callable never leaves the user staring at a spinner.
      // NOTE: gpt-5 family uses `max_completion_tokens`, not `max_tokens`.
      // Passing the old name can be silently ignored and the model may then
      // run for a long time before responding.
      const completionPromise = createOpenAIChatCompletion<any>(
        {
          model: "gpt-5-mini",
          response_format: { type: "json_object" },
          max_completion_tokens: 4000,
          messages: [
            {
              role: "system",
              content:
                "You write structured rich step content for a long-form article reader. Return only valid JSON with keys text, lists, callouts, and optionally images.",
            },
            { role: "user", content: prompt },
          ],
        },
        TEXT_TIMEOUT_MS
      ).then((res) => {
        console.log(
          `${LOG} chat completion resolved at ${Math.round((Date.now() - startedAt) / 1000)}s`
        );
        return res;
      });

      const timeoutPromise = new Promise<never>((_, reject) =>
        setTimeout(() => {
          console.warn(
            `${LOG} local timeout fired after ${Math.round(TEXT_TIMEOUT_MS / 1000)}s`
          );
          reject(
            new Error(
              `Chat completion did not return within ${Math.round(TEXT_TIMEOUT_MS / 1000)}s`
            )
          );
        }, TEXT_TIMEOUT_MS)
      );

      const data = await Promise.race([completionPromise, timeoutPromise]);

      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }

      console.log(`${LOG} raw response`, data);

      const content = data?.choices?.[0]?.message?.content;
      const finishReason = data?.choices?.[0]?.finish_reason;
      const usage = data?.usage;
      console.log(`${LOG} response summary`, {
        contentLength: content?.length || 0,
        finishReason,
        usage,
      });

      if (!content) {
        console.warn(`${LOG} empty content in response`, data);
        this.setState({
          generationProgress:
            "Model returned no content. Check the OpenAI key / quota and try again.",
        });
        return;
      }

      console.debug(`${LOG} raw content`, content);

      let parsed: any = null;
      try {
        const clean = String(content)
          .replace(/^```(?:json)?\s*/i, "")
          .replace(/\s*```$/, "")
          .trim();
        const match = clean.match(/\{[\s\S]*\}/);
        parsed = JSON.parse(match ? match[0] : clean);
        console.log(`${LOG} parsed JSON`, parsed);
      } catch (parseError) {
        console.error(`${LOG} JSON parse failed`, parseError, content);
        this.setState({
          generationProgress:
            "Generated content was not valid JSON. See console for the raw response.",
        });
        return;
      }

      const text = typeof parsed?.text === "string" ? parsed.text.trim() : "";
      const lists = this.normalizeGeneratedLists(parsed?.lists);
      const callouts = this.normalizeGeneratedCallouts(parsed?.callouts);

      console.log(`${LOG} normalized fields`, {
        textLength: text.length,
        listCount: lists.length,
        calloutCount: callouts.length,
        imageCount: Array.isArray(parsed?.images) ? parsed.images.length : 0,
      });

      if (text) this.props.setFieldValue("text", text);
      this.props.setFieldValue("lists", lists);
      this.props.setFieldValue("callouts", callouts);

      // Old per-paragraph audio is keyed to the previous text and will play
      // out of sync if kept. Wipe it whenever we replace the step content.
      let clearedAudioCount = 0;
      if (text) {
        clearedAudioCount = await this.clearStepAudioFiles();
      }

      const elapsed = Math.round((Date.now() - startedAt) / 1000);
      const audioSuffix = clearedAudioCount
        ? ` Cleared ${clearedAudioCount} stale audio file${clearedAudioCount === 1 ? "" : "s"}.`
        : "";
      this.setState({
        generationProgress: `Text generated in ${elapsed}s (${lists.length} lists, ${callouts.length} callouts).${audioSuffix}`,
      });

      if (
        this.state.generateImagesEnabled &&
        Array.isArray(parsed?.images) &&
        parsed.images.length
      ) {
        console.log(`${LOG} starting image generation`, {
          count: parsed.images.length,
        });
        await this.generateAndUploadImages(parsed.images);
      } else {
        console.log(`${LOG} skipping image generation`, {
          generateImagesEnabled: this.state.generateImagesEnabled,
          hasImages: Array.isArray(parsed?.images) && parsed.images.length > 0,
        });
      }

      console.log(
        `${LOG} done at ${Math.round((Date.now() - startedAt) / 1000)}s`
      );
    } catch (error) {
      console.error(`${LOG} threw`, error);
      const reason = error instanceof Error ? error.message : "Unknown error";
      this.setState({
        generationProgress: `Generation failed: ${reason}`,
      });
    } finally {
      if (ticker) clearInterval(ticker);
      this.setState({ isGenerating: false });
    }
  };

  private generateAndUploadImages = async (rawImages: any[]) => {
    const LOG = "[GenerateImages]";
    const { values, setFieldValue } = this.props;
    const stepID = values?.id || "temp";
    const communityId = values?.communityId || "common";
    const targets = rawImages
      .map((img: any, index: number) => ({
        id:
          typeof img?.id === "string" && img.id.trim()
            ? img.id.trim()
            : String(index + 1),
        prompt: typeof img?.prompt === "string" ? img.prompt.trim() : "",
        alt: typeof img?.alt === "string" ? img.alt.trim() : "",
        caption: typeof img?.caption === "string" ? img.caption.trim() : "",
      }))
      .filter((img) => img.prompt);

    console.log(`${LOG} start`, {
      proposed: rawImages.length,
      withPrompt: targets.length,
      stepID,
      communityId,
    });

    if (!targets.length) {
      console.warn(`${LOG} no usable image prompts, skipping`);
      return;
    }

    const total = targets.length;
    const startedAt = Date.now();
    let done = 0;
    const failures: { id: string; reason: string }[] = [];

    const updateProgress = () => {
      const elapsed = Math.round((Date.now() - startedAt) / 1000);
      this.setState({
        generationProgress: `Generating images with gpt-image-2 (${done}/${total} done, ${elapsed}s elapsed)...`,
      });
    };

    updateProgress();
    const ticker = setInterval(updateProgress, 2000);

    const IMAGE_TIMEOUT_MS = 90000; // 90s per image — fail fast instead of hanging

    const results = await Promise.all(
      targets.map(async (img) => {
        const imgStartedAt = Date.now();
        console.log(`${LOG} image ${img.id} dispatching`, {
          promptPreview: img.prompt.slice(0, 120),
        });
        try {
          const response = await createOpenAIImageGeneration<any>(
            {
              model: "gpt-image-2",
              prompt: `${img.prompt} IMPORTANT: No text, letters, words, numbers, typography, watermarks, or writing of any kind. Pure visual only.`,
              n: 1,
              size: "1536x1024",
              quality: "low",
              output_format: "png",
            },
            IMAGE_TIMEOUT_MS
          );
          console.log(
            `${LOG} image ${img.id} returned in ${Math.round((Date.now() - imgStartedAt) / 1000)}s`
          );
          const b64 = response?.data?.[0]?.b64_json;
          if (!b64) throw new Error("No image returned");

          const blob = await (
            await fetch(`data:image/png;base64,${b64}`)
          ).blob();
          const fileName = `ai-${Date.now()}-${img.id}.png`;
          const url = (
            await uploadMedia({
              body: blob,
              kind: "image",
              contentType: "image/png",
              fileName,
              firebasePath:
                `${DB_PATH.IMAGES}/${communityId}/${stepID}/${fileName}`,
            })
          ).url;

          console.log(`${LOG} image ${img.id} uploaded`, { url, fileName });

          return {
            id: img.id,
            url,
            alt: img.alt,
            caption: img.caption,
          };
        } catch (error) {
          const reason =
            error instanceof Error ? error.message : "Unknown error";
          console.error(`${LOG} image ${img.id} failed`, error);
          failures.push({ id: img.id, reason });
          return null;
        } finally {
          done += 1;
          updateProgress();
        }
      })
    );

    clearInterval(ticker);

    const successful = results.filter(
      (r): r is { id: string; url: string; alt: string; caption: string } =>
        r !== null
    );

    const elapsed = Math.round((Date.now() - startedAt) / 1000);
    console.log(`${LOG} done`, {
      total,
      successful: successful.length,
      failed: failures.length,
      elapsedSeconds: elapsed,
      failures,
    });

    if (successful.length) {
      const existing = Array.isArray(values?.images) ? values.images : [];
      const merged = [...existing];
      for (const img of successful) {
        const idx = merged.findIndex((m) => String(m.id) === String(img.id));
        if (idx >= 0) merged[idx] = img;
        else merged.push(img);
      }
      setFieldValue("images", merged);
      console.log(`${LOG} step.images updated`, merged);
    }

    if (failures.length === 0) {
      this.setState({
        generationProgress: `Generated ${successful.length}/${total} image${total === 1 ? "" : "s"} in ${elapsed}s.`,
      });
    } else if (successful.length === 0) {
      this.setState({
        generationProgress: `All ${total} image${total === 1 ? "" : "s"} failed (${elapsed}s). Last error: ${failures[failures.length - 1].reason}`,
      });
    } else {
      this.setState({
        generationProgress: `Generated ${successful.length}/${total} images in ${elapsed}s. ${failures.length} failed: ${failures.map((f) => `#${f.id} (${f.reason})`).join(", ")}`,
      });
    }
  };
}

const CustomForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props: any): DailyStep => {
    const { item, dayPlanID, planID } = props;
    return {
      id: item?.id || "",
      title: item?.title || "",
      subtitle: item?.subtitle || "",
      description: item?.description || "",
      text: item?.text || "",
      quote: item?.quote || "",
      reference: item?.reference || "",
      type: item?.type || DAILY_STEP_TYPE.DEFAULT,
      dayPlanID: item?.dayPlanID || dayPlanID,
      planID: item?.planID || planID,
      xpReward: item?.experienceReward || 0,
      questions: item?.questions || [],
      authorID: item?.authorID || props.authorID,
      communityId: item?.communityId || "",
      authorName: item?.authorName || "",
      actionItems: item?.actionItems || "",
      images: item?.images || [],
      videos: item?.videos || [],
      slides: item?.slides || [],
      reelVoiceAuthorReference: item?.reelVoiceAuthorReference || null,
      reelVoiceAudioUrl: item?.reelVoiceAudioUrl || "",
      reelVoiceTimeline: item?.reelVoiceTimeline || [],
      reelSegments: item?.reelSegments || [],
      videoURL: item?.videoURL || '',
      backgroundImageURL: item?.backgroundImageURL || "",
      sectionTitle: item?.sectionTitle || "",
      position: item?.position || "",
      artifactPrompt: item?.artifactPrompt,
      ctas: Array.isArray(item?.ctas) ? item.ctas : [],
    };
  },

  validationSchema: ({ item, mode }) =>
    Yup.lazy((values) =>
      Yup.object().shape({
        title: Yup.string().required("El nombre es requerido."),
        ctas: Yup.array()
          .of(
            Yup.object().shape({
              label: Yup.string()
                .trim()
                .required("Button label is required.")
                .max(MAX_CTA_LABEL, `Button label must be ${MAX_CTA_LABEL} characters or less.`),
              url: Yup.string()
                .trim()
                .required("Button link is required.")
                .matches(/^https:\/\/\S+$/, "Button link must start with https://"),
            })
          )
          .max(MAX_CTAS, `Up to ${MAX_CTAS} buttons.`),
      })
    ),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode, user } = props;
    const communityId = user?.communityId;

    console.log("Props", props.item);
    const oldMainContent = props.item?.text; // Original content
    const newMainContent = values.text; // Updated content

    if (!!oldMainContent && communityId)
      deleteOldAudioFiles(
        oldMainContent,
        newMainContent,
        communityId,
        values.id
      );
    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    const submittedValues = { ...values };
    if (submittedValues.artifactPrompt?.enabled !== true) {
      delete submittedValues.artifactPrompt;
    }
    // Always send an array so clearing every button also clears it in Firestore
    // (updateDailyStep merges, and merge replaces arrays).
    submittedValues.ctas = (Array.isArray(values.ctas) ? values.ctas : [])
      .slice(0, MAX_CTAS)
      .map((cta: StepCta) => ({
        id: cta.id || Math.random().toString(36).slice(2, 10),
        label: (cta.label || "").trim(),
        url: (cta.url || "").trim(),
      }));
    properCallback(submittedValues);
    setSubmitting(false);
  },
})(DailyStepForm);

const mapStateToProps = (state: any) => ({
  user: state.storeUser,
});

export default connect(mapStateToProps)(CustomForm);
async function deleteOldAudioFiles(
  oldContent,
  newContent,
  communityId,
  stepID
) {
  const storage = firebase.storage();

  // Split content into paragraphs
  const oldParagraphs = oldContent.split("\n\n");
  const newParagraphs = newContent.split("\n\n");

  console.log("OldParagraphs", oldParagraphs);
  console.log("NewParagraphs", newParagraphs);

  console.log("CommunityId", communityId, stepID);
  // Iterate over paragraphs to check for changes
  oldParagraphs.forEach((oldParagraph, index) => {
    const newParagraph = newParagraphs[index];

    // Check if paragraph has changed
    if (oldParagraph !== newParagraph) {
      // Delete audio file for changed paragraph    `Audio/${communityId}/${stepID}/${file.name}`

      const audioRef = storage.ref(
        `${DB_PATH.AUDIO}/${communityId}/${stepID}/${index}.mp3`
      );

      audioRef
        .delete()
        .then(() => {
          console.log(
            "Delete audio",
            `${DB_PATH.AUDIO}/${communityId}/${stepID}/${index}.mp3`
          );
        })
        .catch((error) => {
          console.error(
            `Error deleting audio file for paragraph ${index}:`,
            error
          );
        });
    }
  });
}
